import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { Stack, Typography } from "@mui/material"

import type { AlertSettingParam } from "types/alerts.types"

import ControlledAutocomplete from "widgets/common/ControlledAutocomplete"

interface TelemetryInputProps {
  param: AlertSettingParam
  telemetries: { label: string; value: string }[]
}

const TelemetryInput = ({ param, telemetries }: TelemetryInputProps) => {
  const { t } = useTranslation()
  const { formState } = useFormContext()
  // An alert saved with several fields keeps the multiple picker, so editing it drops none.
  const savedFields = formState.defaultValues?.[param.id]
  const multiple = Array.isArray(savedFields) && savedFields.length > 1

  return (
    <Stack sx={{ width: "100%" }}>
      <Typography sx={{ mb: "1rem" }}>
        {multiple ? param.name : t("alert_settings.FIELD")}
      </Typography>
      <Stack sx={{ flexDirection: "row", mb: "0.5rem" }}>
        <ControlledAutocomplete
          multiple={multiple}
          options={telemetries}
          name={param.id}
        />
      </Stack>
    </Stack>
  )
}

export default TelemetryInput
